<template>
  <div class="flex flex-col flex-1">
    <template v-if="customer.customerName.value == 'oost'">
      <ZccScheduleDayOost
        v-if="yesterday"
        :title="
          dateToReadableShowDate(
            new Date(new Date().setDate(new Date().getDate() - 1))
          )
        "
        :date="new Date(new Date().setDate(new Date().getDate() - 1))"
        :loading="loadingYesterday"
        :data="yesterday"
        :model-value="hideOldSchedulesYesterday"
        @update:model-value="
          (value) => emit('update:hideOldSchedulesYesterday', value)
        "
      ></ZccScheduleDayOost>
      <ZccScheduleDayOost
        v-if="today"
        :title="dateToReadableShowDate(new Date())"
        :date="new Date()"
        :data="today"
        :model-value="hideOldSchedulesToday"
        :loading="loadingToday"
        @update:model-value="
          (value) => emit('update:hideOldSchedulesToday', value)
        "
      ></ZccScheduleDayOost>
    </template>
    <template v-else>
      <ZccScheduleDay
        v-if="yesterday"
        :title="
          dateToReadableShowDate(
            new Date(new Date().setDate(new Date().getDate() - 1))
          )
        "
        :date="new Date(new Date().setDate(new Date().getDate() - 1))"
        :loading="loadingYesterday"
        :data="yesterday"
        :model-value="hideOldSchedulesYesterday"
        @update:model-value="
          (value) => emit('update:hideOldSchedulesYesterday', value)
        "
      ></ZccScheduleDay>
      <ZccScheduleDay
        v-if="today"
        :title="dateToReadableShowDate(new Date())"
        :date="new Date()"
        :data="today"
        :model-value="hideOldSchedulesToday"
        :loading="loadingToday"
        @update:model-value="
          (value) => emit('update:hideOldSchedulesToday', value)
        "
      ></ZccScheduleDay>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { ZccScheduleDay, ZccScheduleDayOost } from "@planbord/ui/components";
import { ScheduleGroup } from "@planbord/shared/models";
import { dateToReadableShowDate } from "@planbord/shared/dates";
import { useCustomerName } from "@planbord/shared/stores";

const customer = useCustomerName();

const emit = defineEmits<{
  (e: "update:hideOldSchedulesYesterday", value: unknown): void;
  (e: "update:hideOldSchedulesToday", value: unknown): void;
}>();

defineProps<{
  yesterday?: ScheduleGroup[];
  today?: ScheduleGroup[];
  loadingYesterday: boolean;
  loadingToday: boolean;
  hideOldSchedulesYesterday: unknown;
  hideOldSchedulesToday: unknown;
}>();
</script>
